import React from 'react';
import UserResearchBanner from '../components/user-research-banner';

// A React component to be rendered on the right side of the top-menu
// eslint-disable-next-line react/display-name
export default () => {
  return <UserResearchBanner />;
};
